import React,{useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import { withStyles,makeStyles, useTheme } from '@material-ui/core/styles';

import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import {LastPage,AllInclusive,Add,MoreVert,Edit,Delete,Done,Block,Visibility,Gavel,FilterList} from '@material-ui/icons';

import { withLocalize,Translate } from "react-localize-redux";

import {
  TableRow ,
  TablePagination,
  TableFooter,
  TableContainer,
  TableCell,
  TableBody,
  Table ,
  TableHead,
  Button,
  IconButton,
  Paper,
  Typography,
  Toolbar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  TextField,
  FormControlLabel,
  Checkbox,
  Container ,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Menu,
  TextareaAutosize,
  Chip,
  LinearProgress,
  CircularProgress,
  FormHelperText,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Grid
} from "@material-ui/core";

import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";

import Format from "date-fns/format";

import {useHistory } from "react-router-dom";

import MUIDataTable from "mui-datatables";

import { useSnackbar } from 'notistack';

import {TransportService} from "./../../utils/web_config_2";

import UserInfo from "./login_info";

import axios from 'axios';

import DateFnsUtils from "@date-io/date-fns";

import Chart from 'react-apexcharts';

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    flexFlow:1,
    [theme.breakpoints.up('sm')]:{
      marginLeft:250,
    }
  },
  btn:{
    textTransform:"capitalize",
  },
  formTitle:{
    flexGrow:1,
}
}));


 function DailyFinesReport() {
  const classes = useStyles1();

  // new offense dialog 

  const [open, setOpen] = useState(false);

  const [operatorData, setOperatorData] = useState({});

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [fineMessage,setFineMessage]=useState("Loading...");

  const [finteTitle,setFineTitle]=useState("Daily report");

  

  const history = useHistory();


  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

//offenses table 


const columns = [
  {
    name: "id",
    label: "id",
    options: {
     display:false,
     filter: true,
     sort: true,
    }
   },
  {
   name: "driver_name",
   label: "Driver Name",
   options: {
    filter: true,
    sort: true,
   }
  },
  {
   name: "offender",
   label: "Offender",
   options: {
    filter: true,
    sort: false,
   }
  },
  {
   name: "totalAmount",
   label: "Amount",
   options: {
    filter: true,
    sort: false,
   }
  }, {
    name: "plate_number",
    label: "Plate Number",
    options: {
     filter: true,
     sort: true,
    }
   },
   {
    name: "vehicle_type",
    label: "Vehicle Type",
    options: {
     filter: true,
     sort: false,
    }
   },
   {
    name: "createdAt",
    label: "Date Time",
    options: {
     filter: true,
     sort: false,
    }
   }
 ];

 
 const options = {textLabels: {
  body: {
    noMatch: fineMessage
  },
},
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:"single",
   rowsPerPage: 10,
   elevation:0,
  customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
    <Box>
      <Chip 
      className={classes.chip} 
      icon={ <Visibility/>} 
      color="primary" 
      variant="outlined" 
      label="View offenses" 
      onClick={()=>{
 var id=displayData[selectedRows.data[0]['index']]['data'][0];
 console.log("iiiiiiiiiiidddddddddd",id);
 get_offenses(id);
}} />
      </Box>
  ),
 };


 useEffect(()=>{

  var data = {};
  const data1 = localStorage.getItem("nx_op");
  if (data1 != null) {
    data = JSON.parse(data1);
  }

  setOperatorData(data);
  axios.defaults.baseURL = new TransportService().BASE_URL;

  get_fines(data.token);

  console.log(data.token);

 },[]);

// driver performance


const [driverLabels,setDriverLabels]=useState([]);
const [driverSeries,setDriverSeries]=useState([]);


const driver_performance= 
{options:{
    series: driverSeries,
    chart: {
    width: 380,
    type: 'pie',
  },
  labels: driverLabels,
  legend: {
    position: 'right',
    itemMargin:{
        horizontal:0
    }
  },
  responsive: [{
    breakpoint: 480,
    options: {
      chart: {
        width: 280,
        height:280
      },
      legend: {
        position: 'right'
      }
    }
  }]
  }
};

 const getDate=()=>{
    return Format(new Date(), ["yyyy-MM-dd",]);
 }


 // summary 


 const [totalFines,setTotalFines]=useState(0);
 const [totalAmount,setTotalAmount]=useState(0);

 // get fines
const [fineLoad,setFineLoad]=useState(false);
 const [fines,setFines]=useState([]);
 const get_fines=(token)=>{
  setFineTitle("Daily report");
  setFineMessage("Loading...");
   setFineLoad(true);
   const fineInstance = axios.create(new TransportService().setHeaders(token));
   fineInstance.put('/api/v1/fines/getAllFineTicketsByOperatorAndDate',
    {
        "from_date": getDate(),
        "operator_id": new UserInfo().ID,
        "to_date": getDate()
      }
   )
   .then(res=>{
    setFineMessage("");
     var objs=res.data;
     console.log("== objs ==",objs);

     if(objs.length==0){
        setFineMessage("No Fines Issued Today");
     }

     var l=[];
     var s=[];
     var ids=[];
     var tot=0;

     objs.map((o)=>{
      ids.push(o['driver']['id']);
    });

    


    var unique_driver=ids.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
    console.log("unique_driver",unique_driver);

    unique_driver.map((u)=>{
    
      var off=0;
      var name="";

      for(var i=0;i<objs.length;i++){
        if(objs[i]['driver']['id']==u){
          // off=off+objs[i]['offences'].length;
          name=objs[i]['driver']['first_name']+" "+objs[i]['driver']['last_name'];
        }
      }
      l.push(name);
      s.push(off);
    });

    


    console.log("=l=",l);
    console.log("=s=",s);

    setDriverLabels(l);
    setDriverSeries(s);

    setTotalFines(s.reduce((a,b)=>a+b,0));
    
    console.log("== ids ==",unique_driver.length);

     objs.map((o)=>{
       tot=tot+parseInt(o['totalAmount']);
       o['driver_name']=o.driver!=null?o.driver.first_name+" "+o.driver.last_name:"null";
       o['plate_number']=o.vehicle!=null?o.vehicle.number_plate:"null";
       o['vehicle_type']=o.vehicle!=null?o.vehicle.v_type:"null";
       o['totalAmount']=formatMoney(parseInt(o['totalAmount']),0)+" ";
     });

     setFineLoad(false);
     setFines(objs);
     setTotalAmount(tot);
   }).catch(err=>{
     setFineLoad(false);
     if(err.response){
      if(err.response.status==401){
        history.push("/", { expired: true });
        enqueueSnackbar(err.message, { 
        variant: 'error',
        });
        }
        if(err.response.status==400){
          setFineMessage("No fines ticket available");
          enqueueSnackbar("No fines ticket available",
            { 
              variant: 'info'
          });
        }
     }
     
    // enqueueSnackbar(err.message,
    //   { 
    //     variant: 'error'
    // });
   });
   
 }


 // offense dialog 
 const [offenseDialog,setOffenseDialog]=useState(false);
 // get offense 
 const [offenses,setOffenses]=useState([]);
 const get_offenses=(id)=>{
   var of=fines.find((o)=>o.id==id);
  //  setOffenses(of['offences']);
   setOffenseDialog(true);
 }

   // format money 

   function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
  
      const negativeSign = amount < 0 ? "-" : "";
  
      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;
  
      return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
      console.log(e)
    }
  };



  // filter dialog 



  const [filterLoad,setFilterLoad]=useState(false);
  const [filterDialog,setFilterDialog]=useState(false);
  const [startDate,setStartDate]=useState({value:Format(new Date(), ["yyyy-MM-dd",]),error:""});
  const [endDate,setEndDate]=useState({value:Format(new Date(), ["yyyy-MM-dd",]),error:""});
  const filter_report=()=>{
    setFineTitle("Report from:"+startDate.value+", To:"+endDate.value);
    setFilterLoad(true);
    const reportInstance = axios.create(new TransportService().setHeaders(operatorData.token));
    reportInstance.put('/api/v1/fines/getAllFineTicketsByOperatorAndDatesInterval',{
      "from_date":startDate.value,
      "operator_id":new UserInfo().ID,
      "to_date": endDate.value
    })
    .then(res=>{    
      var objs=res.data;
      console.log("== objs ==",objs);
      if(objs.length==0){
         setFineMessage("No Fines Issued Today");
      }
      var l=[];
      var s=[];
      var ids=[];
      var tot=0;
 
      objs.map((o)=>{
       ids.push(o['driver']['id']);
     });
 
 
     var unique_driver=ids.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
 
     unique_driver.map((u)=>{
     
       var off=0;
       var name="";
 
       for(var i=0;i<objs.length;i++){
         if(objs[i]['driver']['id']==u){
          //  off=off+objs[i]['offences'].length;
           name=objs[i]['driver']['first_name']+" "+objs[i]['driver']['last_name'];
         }
       }
       l.push(name);
       s.push(off);
     });
 
 
     console.log("=l=",l);
     console.log("=s=",s);
 
     setDriverLabels(l);
     setDriverSeries(s);
 
     setTotalFines(s.reduce((a,b)=>a+b,0));
     
 
     console.log("== ids ==",unique_driver.length);
 
 
 
      objs.map((o)=>{
        tot=tot+parseInt(o['totalAmount']);
        o['driver_name']=o.driver!=null?o.driver.first_name+" "+o.driver.last_name:"null";
        o['plate_number']=o.vehicle!=null?o.vehicle.number_plate:"null";
        o['vehicle_type']=o.vehicle!=null?o.vehicle.v_type:"null";
        o['totalAmount']=formatMoney(parseInt(o['totalAmount']),0)+" FRW";
      });
      setFines(res.data);
      setTotalAmount(tot);
      setFilterLoad(false);
    })
    .catch(err=>{
      setFilterLoad(false);
    });
  }


  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
    <div className={classes.root}>
      <Box display="flex">
 
 <Box display="flex" alignItems="center" mt={2} className={classes.formTitle}>
 
 <Box mr={1}><Gavel fontSize="large" color="primary"/></Box> <Typography  variant="h5" color="default"><b>Daily Fines Report</b></Typography>

 </Box>
 
 <Button
 variant="outlined"
 color="primary"
 size="small"
 className={classes.btn}
 startIcon={<FilterList/>}
 onClick={()=>{
  setFilterDialog(true);
 }}
 >
   Filter
 </Button>

</Box>


<Box mt={2}>
  <Grid container spacing={1}>
    <Grid item xs={12} md={8} lg={8} sm={8}>

{/* fines report table  */}

<Box>
{fineLoad&&<LinearProgress/>}
<MUIDataTable
  title={finteTitle}
  data={fines}
  columns={columns}
  options={options}
/>
</Box>

    </Grid>
    <Grid item xs={12} md={4} lg={4} sm={4}>

    <Paper className={classes.paper} elevation={0}>

<Box p={1}>

<Grid container>
                <Grid item xs={12} md={12}>
                   <Box><Typography variant="h6" className={classes.title}>Summary</Typography></Box>
                 </Grid>
      
      
                 <Grid item xs={12} md={12}>
      
                 <Grid item md={12} lg={12} xs={6} md={8}>
                <Chart options={driver_performance.options} series={driver_performance.options.series} type="pie" width={"100%"} height={"100%"} />
               </Grid>
      
                 </Grid>

                     <Grid item md={6} xs={6} sm={6} lg={6}>
                         <Grid container>
                             <Grid item sm={12} xs={12} md={12} lg={12}>
                             <Typography>Offenses </Typography>
                             </Grid>
                             <Grid item sm={12} xs={12} md={12} lg={12}>
                            <Typography variant="h5">{totalFines}</Typography> 
                             </Grid>

                         </Grid>
                         
                     </Grid>
                     <Grid item md={6} xs={6} sm={6} lg={6}>
                     <Grid container>
                             <Grid item sm={12} xs={12} md={12} lg={12}>
                             <Typography>Total Amount </Typography>
                             </Grid>
                             <Grid item sm={12} xs={12} md={12} lg={12}>
<Typography variant="h5">{formatMoney(totalAmount,0)} FRW</Typography> 
                             </Grid>

                         </Grid>
                     </Grid>
      
      
                  </Grid>   
                
</Box>

                 
    </Paper>
              
    </Grid>
  </Grid>
  

</Box> 


{/* offense dialog  */}



<Dialog
    maxWidth="sm"
    fullWidth
        open={offenseDialog}
        onClose={()=>{
          setOffenseDialog(false);
        }}
        aria-labelledby="fines"
        aria-describedby="fines"
      >
        <DialogTitle id="fines">{"Fines"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
          <Box>
          <List>
            {offenses.map((o)=>{
              return  <ListItem>
              <ListItemAvatar>
                  <Gavel/>
              </ListItemAvatar>
              <ListItemText primary={o['offense']['name']} secondary={o['amount']+" FRW"} />
            </ListItem>;
            })}
     
      
    </List>
        
          </Box>
         </DialogContentText>
         </DialogContent>

         <DialogActions>
         
          <Button onClick={()=>{
             setOffenseDialog(false);
          }} color="secondary" className={classes.btn}>
            <Typography>Close</Typography>
          </Button>


        </DialogActions>
         </Dialog>



{/* filter dialog  */}





<Dialog
    maxWidth="sm"
    fullWidth
        open={filterDialog}
        onClose={()=>{
            setFilterDialog(false);
        }}
        aria-labelledby="filter"
        aria-describedby="filter"
      >
        <DialogTitle id="filter">{"Filter"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
          <Box>
             
         
          <Box mt={1}>
                          <DatePicker
                            fullWidth
                            disableToolbar
                            variant="inline"
                            format="yyyy-MM-dd"
                            margin="dense"
                            
                            autoOk
                            label="Start date"
                            value={startDate.value}
                            inputVariant="outlined"
                            onChange={(v)=>{
                                console.log("choosen1: ", Format(v, ["yyyy-MM-dd",]));
                               
                                setStartDate({value:Format(v, ["yyyy-MM-dd",]),error:""});
                            }}
                            InputProps={{
                              disableUnderline: true,
                              style: { paddingRight: 0 },
                            }}
                          />
        
          </Box>
          <Box mt={1}>
                          <DatePicker
                            fullWidth
                            disableToolbar
                            variant="inline"
                            format="yyyy-MM-dd"
                            margin="dense"
                            
                            autoOk
                            label="End date"
                            value={endDate.value}
                            inputVariant="outlined"
                            onChange={(v)=>{
                                console.log("choosen2: ",v);
                                setEndDate({value:Format(v, ["yyyy-MM-dd",]),error:""});
                            }}
                            InputProps={{
                              disableUnderline: true,
                              style: { paddingRight: 0 },
                            }}
                          />
            </Box>

          </Box>
         </DialogContentText>
         </DialogContent>

         <DialogActions>
         
          <Button onClick={()=>{
              setFilterDialog(false);
          }} color="secondary" className={classes.btn}>
            <Typography>Close</Typography>
          </Button>


            
          <Button onClick={()=>{

            filter_report();

          }} color="primary" variant="contained" className={classes.btn}>
              {filterLoad?<CircularProgress size={25} color="secondary"/>:
              <Typography>View</Typography>
              }
          </Button>


        </DialogActions>
         </Dialog>



 </div>
 </MuiPickersUtilsProvider>
  );
}

export default withLocalize(DailyFinesReport)